import { Pipe, PipeTransform } from '@angular/core';
import { TimeDuration } from '../../models/rdata/time-duration';

@Pipe({
  name: 'salaryRateDuration',
  standalone: true
})
export class SalaryRateDurationPipe implements PipeTransform {

  transform(value: TimeDuration | null, placeholder?: string): string {
    if(!!value){
      return `${value.toLocaleLowerCase().replace('s', '')}`
    }

    return placeholder ?? 'Time duration not found';
  }

}
